module.exports = __webpack_public_path__ + "img/click-user.1107c225.svg";